import { RootState } from '../../types';

const all = (state: RootState) => state.user.promocodes;
export const loading = (state: RootState) => all(state).loading;
export const ready = (state: RootState) => all(state).ready;
export const checkLoading = (state: RootState) => all(state).checkLoading;
export const error = (state: RootState) => all(state).error;
export const promocodes = (state: RootState) => all(state).promocodes;
export const checked = (state: RootState) => all(state).checked;
